import { BreakpointValueProp } from "@store/Framework/Common/Utilities/breakpointValues";
import getCurrentBreakpointValue from "@store/Framework/Common/Utilities/getCurrentBreakpointValue";
import { useWindowContext } from "@store/Framework/Components/WindowContext";
import { useTheme } from "styled-components";

const useCurrentBreakpointValue = <T extends BreakpointValueProp<any>>(values: T) => {
    const theme = useTheme();
    const { currentBreakpoint } = useWindowContext();

    return getCurrentBreakpointValue(values, currentBreakpoint, theme);
};

export default useCurrentBreakpointValue;
